/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Major_Active_Wolf_OfferInputs */

const fr_major_active_wolf_offer = /** @type {(inputs: Major_Active_Wolf_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

/**

* @param {Major_Active_Wolf_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const major_active_wolf_offer = /** @type {((inputs?: Major_Active_Wolf_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Major_Active_Wolf_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_major_active_wolf_offer(inputs)
});